export const sorter = new Intl.Collator('da-DK', {
  ignorePunctuation: false,
  sensitivity: "accent",
  usage: 'sort'
});

export function sortByDanishLanguageRules(a: string, b: string)
{
  return sorter.compare(a,b);
}

export function sortElectoralCoalitionMembers(coalitionMembers: string) {
  let members = coalitionMembers.split(",").map(member => member.trim());
  let candidateListWithLetter = members.filter(member => member.length === 1);
  let candidateListWithoutLetter = members.filter(member => member.length > 1);
  
  candidateListWithLetter.sort(sortByDanishLanguageRules);
  candidateListWithoutLetter.sort(sortByDanishLanguageRules);
  let sortedMembers = [ ...candidateListWithLetter, ...candidateListWithoutLetter ]
  return sortedMembers.join(", ")
}

export function sortByAlphabeticallyIgnoreCase(a: string, b: string) {
  return sortByDanishLanguageRules(a.toLowerCase(), b.toLowerCase());
}

export function sortByNumberedString(current: string, next: string) {
  const currentStringTokens = current.split(". ");
  const nextStringTokens = next.split(". ");

  if(currentStringTokens.length == 1 || nextStringTokens.length == 1)
  {
    return sortByAlphabeticallyIgnoreCase(current, next);
  }
  
  const currentNumber = parseInt(currentStringTokens[0]);
  const currentName = currentStringTokens[1];
  const nextNumber = parseInt(nextStringTokens[0]);
  const nextName = nextStringTokens[1];

  if(currentNumber > nextNumber)
  {
    return 1;
  } else if(currentNumber == nextNumber) {
    return sortByAlphabeticallyIgnoreCase(currentName, nextName);
  }else {
    return -1;
  }
}

export function sortByDate(current: string, next: string) {
  const currentDate = new Date(current);

  const nextDate = new Date(next);

  if(currentDate > nextDate) {
    return 1;
  }
  else {
    return -1;
  }
}
